const SportsModule = () => import(/* webpackChunkName: "sports-module" */ './views/Module.vue'); 
const InPlay = () => import(/* webpackChunkName: "sports" */ './views/InPlay.vue');
const SportEventDetail = () => import(/* webpackChunkName: "sport-event-detail" */ './views/SportEventDetail.vue');
const Sports = () => import(/* webpackChunkName: "sports" */ './views/Sports.vue');

const SportsRoutes =   {
    path: '/',
    component: SportsModule,
    children: [
      {
        path: 'inplay',
        name: 'inplay',
        component: InPlay
      },
      {
        path: 'sports/:type/:id',
        name: 'sports',
        component: Sports
      },
      {
        path: 'sports-event-detail/:event_id',
        name: 'sports-event-detail',
        component: SportEventDetail
      },
    ],
  }

export default SportsRoutes;